export const freshdeskScript: string = `
  window.fwSettings={'widget_id':9000000957};
  !function(){
    if("function"!=typeof window.FreshworksWidget){
      var n=function(){n.q.push(arguments)};
      n.q=[],window.FreshworksWidget=n
    }
  }()`;
